module.exports = __webpack_public_path__ + "media/St 4-thermostat2-correct.b03bf33f.wav";